// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Theme */
.theme--light.v-input--selection-controls.v-input--is-disabled .v-icon {
  color: rgba(0,0,0,0.26) !important;
}
.theme--dark.v-input--selection-controls.v-input--is-disabled .v-icon {
  color: rgba(255,255,255,0.3) !important;
}
.application--is-rtl .v-input--selection-controls .v-input--selection-controls__input {
  margin-right: 0;
  margin-left: 8px;
}
.v-input--selection-controls {
  margin-top: 16px;
  padding-top: 4px;
}
.v-input--selection-controls .v-input__append-outer,
.v-input--selection-controls .v-input__prepend-outer {
  margin-top: 0;
  margin-bottom: 0;
}
.v-input--selection-controls .v-input__control {
  flex-grow: 0;
  width: auto;
}
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 12px;
}
.v-input--selection-controls__input {
  color: inherit;
  display: inline-flex;
  flex: 0 0 auto;
  height: 24px;
  position: relative;
  margin-right: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-property: color, transform;
  width: 24px;
  user-select: none;
}
.v-input--selection-controls__input input {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  user-select: none;
}
.v-input--selection-controls__input + .v-label {
  cursor: pointer;
  user-select: none;
}
.v-input--selection-controls__ripple {
  border-radius: 50%;
  cursor: pointer;
  height: 34px;
  position: absolute;
  transition: inherit;
  width: 34px;
  left: -12px;
  top: calc(50% - 24px);
  margin: 7px;
}
.v-input--selection-controls__ripple:before {
  border-radius: inherit;
  bottom: 0;
  content: '';
  position: absolute;
  opacity: 0.2;
  left: 0;
  right: 0;
  top: 0;
  transform-origin: center center;
  transform: scale(0.2);
  transition: inherit;
}
.v-input--selection-controls__ripple .v-ripple__container {
  transform: scale(1.4);
}
.v-input--selection-controls.v-input .v-label {
  align-items: center;
  display: inline-flex;
  top: 0;
  height: auto;
}
.v-input--selection-controls.v-input--is-focused .v-input--selection-controls__ripple:before,
.v-input--selection-controls .v-radio--is-focused .v-input--selection-controls__ripple:before {
  background: currentColor;
  transform: scale(0.8);
}
`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/src/stylus/components/_selection-controls.styl"],"names":[],"mappings":"AAGA,WAAA;AAGI;EAEE,kCAAyB;AAL/B;AAGI;EAEE,uCAAyB;AAF/B;AAKE;EACE,eAAc;EACd,gBAAa;AAHjB;AAQA;EACE,gBAAY;EACZ,gBAAa;AANf;AAQE;;EAEE,aAAY;EACZ,gBAAe;AANnB;AAQE;EACE,YAAW;EACX,WAAO;AANX;AASI;EACE,mBAAe;AAPrB;AASE;EACE,cAAO;EACP,oBAAS;EACT,cAAM;EACN,YAAQ;EACR,kBAAU;EACV,iBAAc;EACd,iDAAY;EACZ,qCAA0B;EAC1B,WAAO;EACP,iBAAa;AAPjB;AASI;EACE,kBAAU;EACV,UAAS;EACT,WAAO;EACP,YAAQ;EACR,eAAQ;EACR,iBAAa;AAPnB;AAUI;EACE,eAAQ;EACR,iBAAa;AARnB;AAUE;EACE,kBAAe;EACf,eAAQ;EACR,YAAQ;EACR,kBAAU;EACV,mBAAY;EACZ,WAAO;EACP,WAAM;EACN,qBAAK;EACL,WAAQ;AARZ;AAUI;EACE,sBAAe;EACf,SAAQ;EACR,WAAS;EACT,kBAAU;EACV,YAAS;EACT,OAAM;EACN,QAAO;EACP,MAAK;EACL,+BAAkB;EAClB,qBAAW;EACX,mBAAY;AARlB;AAUI;EACE,qBAAW;AARjB;AAUE;EACE,mBAAa;EACb,oBAAS;EACT,MAAK;EACL,YAAQ;AARZ;AAYI;;EACE,wBAAY;EACZ,qBAAW;AATjB","sourcesContent":["@import '../bootstrap'\n@import '../theme'\n\n/** Theme */\nselection-control($material)\n  &.v-input--is-disabled\n    .v-icon\n      // needed for helper override\n      color: $material.buttons.disabled !important\n\nv-selection-control-rtl()\n  .v-input--selection-controls__input\n    margin-right: 0\n    margin-left: 8px\n\ntheme(selection-control, \"v-input--selection-controls\")\nrtl(v-selection-control-rtl, \"v-input--selection-controls\")\n\n.v-input--selection-controls\n  margin-top: $input-top-spacing\n  padding-top: 4px\n\n  .v-input__append-outer,\n  .v-input__prepend-outer\n    margin-top: 0\n    margin-bottom: 0\n\n  .v-input__control\n    flex-grow: 0\n    width: auto\n\n  &:not(.v-input--hide-details)\n    .v-input__slot\n      margin-bottom: 12px\n\n  &__input\n    color: inherit\n    display: inline-flex\n    flex: 0 0 auto\n    height: 24px\n    position: relative\n    margin-right: 8px\n    transition: .3s cubic-bezier(.25,.8,.25,1)\n    transition-property: color, transform\n    width: 24px\n    user-select: none\n\n    input\n      position: absolute\n      opacity: 0\n      width: 100%\n      height: 100%\n      cursor: pointer\n      user-select: none\n\n    // Sibling selector to avoid targeting v-radio-group's label\n    & + .v-label\n      cursor: pointer\n      user-select: none\n\n  &__ripple\n    border-radius: 50%\n    cursor: pointer\n    height: 34px\n    position: absolute\n    transition: inherit\n    width: 34px\n    left: -12px\n    top: calc(50% - 24px)\n    margin: 7px\n\n    &:before\n      border-radius: inherit\n      bottom: 0\n      content: ''\n      position: absolute\n      opacity: .2\n      left: 0\n      right: 0\n      top: 0\n      transform-origin: center center\n      transform: scale(0.2)\n      transition: inherit\n\n    .v-ripple__container\n      transform: scale(1.4)\n\n  &.v-input .v-label\n    align-items: center\n    display: inline-flex\n    top: 0\n    height: auto\n\n  &.v-input--is-focused,\n  .v-radio--is-focused\n    .v-input--selection-controls__ripple:before\n      background: currentColor\n      transform: scale(.8)\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
